export default __webpack_public_path__ + "static/media/Coco 9781408324981.9eeca8fd.jpg";